import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CartCouponModule } from '@spartacus/cart/base/components';
import { CartValidationGuard } from '@spartacus/cart/base/core';
import { CartNotEmptyGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import {
  CardModule,
  FormErrorsModule,
  MediaModule,
  SpinnerModule
} from '@spartacus/storefront';
import { CustomIconsModule } from '../../../../../../custom/icons/custom-icons.module';
import { CustomCheckoutAuthGuard } from '../../guards/custom-checkout-auth.guard';
import { CustomPlaceOrderModule } from "../custom-place-order/custom-place-order.module";
import { CustomPaymentTypeComponent } from './custom-payment-type.component';

@NgModule({
  declarations: [CustomPaymentTypeComponent],
  exports: [CustomPaymentTypeComponent],
  imports: [
    CommonModule,
    RouterModule,
    CardModule,
    SpinnerModule,
    I18nModule,
    UrlModule,
    FormErrorsModule,
    CartCouponModule,
    CustomIconsModule,
    CustomPlaceOrderModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutPaymentType: {
          component: CustomPaymentTypeComponent,
          guards: [CustomCheckoutAuthGuard, CartNotEmptyGuard, CartValidationGuard],
        },
      },
    } as CmsConfig),
    ReactiveFormsModule,
    MediaModule
  ]
})
export class CustomPaymentTypeModule { }
